// 轨道类型枚举
const EnumKFTTReal3 = 3 // 三维向量(double3)类型

// 轨道属性链接类型枚举
const EnumAPBTTranslation = 1 // 位置属性绑定

// const EnumKFTTQuaternion = 5 // 四元数(quat<double>)类型

// const EnumAPBTRotation = 2 // 旋转属性绑定

/* eslint-disable no-await-in-loop */
const loadPath = async (clip, nodePtr, pathList) => {
  const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  if (clipTrackCount > 0) {
    await player.Native.KeyframeTrack.clearTrack(clip)
  }

  // 创建位置关键帧轨道
  const trackT = await player.Native.KeyframeTrack.addTrackWithParam(clip, nodePtr, {
    name: 'trackLocalTranslation',
    trackType: EnumKFTTReal3,
    propertyLinkType: EnumAPBTTranslation
  })

  for (let i = 0; i < pathList.length; i += 1) {
    const item = pathList[i]
    // 添加位置关键帧
    player.Native.KeyframeTrack.keyAppend(trackT, item.time, item.pos)
  }
}


const loadTransitionAction = async (nodePtr, name, pathList, isLoop) => {
  // 创建路径动画混合器
  const mixer = await player.Native.AnimationMixer.getMixer(name)
  const clip = await player.Native.AnimationClip.getClip(mixer, name)
  const action = await player.Native.AnimationAction.clipAction(mixer, clip)
  await loadPath(clip, nodePtr, pathList)
  // 获取动画片段控制器
  // 绑定动画片段更新通知
  // player.Native.AnimationAction.bindActionUpdate(action)
  // 设置为循环模式播放
  player.Native.AnimationAction.setLoop(action, isLoop ? 1 : 0, -1)
  player.Native.AnimationAction.play(action)
  return {
    mixer,
    action,
    clip
  }
}

const batchFormTransitionAction = async (nodePtr, path, time, tagCode) => {
  const node = {
    nodePtr,
    trackParam: {
      trackType: EnumKFTTReal3,
      propertyLinkType: EnumAPBTTranslation
    },
    loopMode: 0,
    repetitions: -1,
    path,
    time,
    tagCode,
  }
  return node
}

const calcTransition = (mincoord, maxcoord, minValue, maxValue, curValue) => {
  if (curValue <= minValue) {
    curValue = minValue
  } else if (curValue >= maxValue) {
    curValue = maxValue
  }
  const curValueX = (maxcoord[0] - mincoord[0]) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord[0])
  const curValueY = (maxcoord[1] - mincoord[1]) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord[1])
  const curValueZ = (maxcoord[2] - mincoord[2]) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord[2])

  return {
    curValueX, curValueY, curValueZ
  }
}

const destroyTransition = async () => {

}

export {
  loadTransitionAction,
  batchFormTransitionAction,
  calcTransition,
  destroyTransition,
}
